import { render, staticRenderFns } from "./JourneyResponses.vue?vue&type=template&id=22f3940e&scoped=true&"
import script from "./JourneyResponses.vue?vue&type=script&lang=js&"
export * from "./JourneyResponses.vue?vue&type=script&lang=js&"
import style0 from "./JourneyResponses.vue?vue&type=style&index=0&id=22f3940e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3940e",
  null
  
)

export default component.exports